/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaderboardRankPoints
 */
export interface LeaderboardRankPoints {
    /**
     * 
     * @type {number}
     * @memberof LeaderboardRankPoints
     */
    minRank: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardRankPoints
     */
    maxRank: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardRankPoints
     */
    points: number;
}

/**
 * Check if a given object implements the LeaderboardRankPoints interface.
 */
export function instanceOfLeaderboardRankPoints(value: object): value is LeaderboardRankPoints {
    if (!('minRank' in value) || value['minRank'] === undefined) return false;
    if (!('maxRank' in value) || value['maxRank'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    return true;
}

export function LeaderboardRankPointsFromJSON(json: any): LeaderboardRankPoints {
    return LeaderboardRankPointsFromJSONTyped(json, false);
}

export function LeaderboardRankPointsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardRankPoints {
    if (json == null) {
        return json;
    }
    return {
        
        'minRank': json['minRank'],
        'maxRank': json['maxRank'],
        'points': json['points'],
    };
}

export function LeaderboardRankPointsToJSON(json: any): LeaderboardRankPoints {
    return LeaderboardRankPointsToJSONTyped(json, false);
}

export function LeaderboardRankPointsToJSONTyped(value?: LeaderboardRankPoints | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minRank': value['minRank'],
        'maxRank': value['maxRank'],
        'points': value['points'],
    };
}

